import { ErrorHandler, inject, Injectable } from '@angular/core'
import { ErrorService } from './error.service'

@Injectable({
    providedIn: 'root'
})
export class ErrorHandlerService implements ErrorHandler {
    private readonly errorService = inject(ErrorService)

    handleError(error: Error) {
        this.errorService.set(error)
        throw error
    }
}
